import { GButton, GSlideOver, GTooltip } from 'components/basic-blocks'
import { eventLinkGenerator } from 'config/notificationsLinksMapping'
import { RiCheckLine, RiCloseLine } from 'react-icons/ri'
import { useAssetStore, useUiStore } from 'store'
import { GVirtuosoList } from '../../../components/basic-blocks/g-virtualized-list/virtuos-virtulized-lits'
import { NotificationItem } from './notificationItem'
import { SlideOverNotificationsProps } from './types'

export const SlideOverNotifications = (props: SlideOverNotificationsProps) => {
	const {
		open,
		setOpen,
		state,
		onReadOneNotification,
		onReadAllNotification,
		notificationId
	} = props
	const isLoading = useUiStore((s) => s.isLoading)
	const { demoMode } = useAssetStore()

	return (
		<GSlideOver position="right" open={open} setOpen={setOpen} size="lg">
			<div>
				<div className="py-4 px-4">
					<div className="flex justify-between items-center mb-4">
						<div className="text-2xl font-medium">Notifications</div>
						<div className="bg-popover p-2 rounded-md hover:bg-popover-hover">
							<RiCloseLine
								className="text-t-desc-gray w-5 h-5 cursor-pointer"
								onClick={() => setOpen(false)}
							/>
						</div>
					</div>

					{state.notifications?.length === 0 && (
						<div className="flex items-center justify-center text-t-dark mt-2 px-14">
							No notifications available
						</div>
					)}
					{state.notifications?.length > 0 && (
						<div className='bg-popover shadow-dropShadow rounded-3xl '>
							<div className="overflow-y-hidden  p-4 pr-2 overflow-x-hidden h-[calc(100vh-180px)] min-w-[430px]">
								<GVirtuosoList
									length={state.notifications.length}
									height={'100%'}
								 >
									{(index: number) => {
										const link = eventLinkGenerator(state.notifications[index])
										return (
											<NotificationItem
												solo={state.notifications.length === 1}
												key={state.notifications[index].id}
												link={link}
												data={state.notifications[index]}
												notificationId={notificationId}
												className="border-b py-3"
												unreadIcon={
													<GButton
														className="z-10 text-t-gray-hold outline-none border-none bg-transparent hover:bg-transparent shadow-none "
														type="icon"
														icon={RiCloseLine}
														size="xxs"
														onClick={() =>
															onReadOneNotification(
																state.notifications[index].id
															)
														}
													>
														Mark as read
													</GButton>
												}
											/>
										)
									}}
								</GVirtuosoList>
							</div>
							<div className="flex px-4 pb-4 items-center justify-center gap-3 ">
								<GTooltip
									position="top"
									arrowClassName="w-0 h-0 absolute bottom-[0.5px] border-l-8 border-l-transparent  border-r-8 border-r-transparent border-t-8 border-t-tooltip-caret"
									contentClassName="border-none font-grotesk mb-2 bg-t-smoke w-[300px] font-medium text-sm text-t-desc-gray"
									content={demoMode ? 'This action is disabled when demo data is displayed' : ''}>
									<GButton
										label="Mark all as read"
										icon={RiCheckLine}
										color="yellow"
										labelClassName="font-medium text-base"
										className="w-full rounded-full disabled:!shadow-none !shadow-s-yellow"
										disabled={demoMode}
										onClick={() => onReadAllNotification()}
										loading={isLoading('READ_NOTIFICATIONS')}
									/>
								</GTooltip>
							</div>
						</div>
					)}
				</div>
			</div>
		</GSlideOver>
	)
}
